import React from 'react';
export default function isVeneerIcon(icon) {
  return (
    // @ts-expect-error todo: better way to detect veneer icons
    icon && /*#__PURE__*/React.isValidElement(icon) && icon.type && icon.type.isVeneerIcon
  );
}